import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalFontFamilyResolver
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.window.ComposeViewport
import com.appcreator.compose.extensions.JSEvaluationConfig
import com.appcreator.shared.AppCreator
import com.appcreator.shared.AppCreatorSetup
import com.appcreator.shared.BuildKonfig
import kotlinx.browser.window
import org.jetbrains.compose.resources.configureWebResources
import org.jetbrains.skiko.wasm.onWasmReady
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import org.jetbrains.compose.resources.Font
import thedailycardioadmin.shared.generated.resources.Res
import thedailycardioadmin.shared.generated.resources.noto_color_emoji_regular

fun main() {

    Firebase.initialize(options = FirebaseOptions(
        apiKey = BuildKonfig.firebaseApiKey,
        authDomain = BuildKonfig.firebaseAuthDomain,
        projectId = BuildKonfig.firebaseProjectId,
        storageBucket = BuildKonfig.firebaseStorageBucket,
        gcmSenderId = BuildKonfig.firebaseGcmSenderId,
        applicationId = BuildKonfig.firebaseApplicationId,
        gaTrackingId = BuildKonfig.firebaseGaTrackingId,
    ))

    val origin = window.location.origin
    configureWebResources {
        resourcePathMapping { "$origin/$it" }
    }

    AppCreatorSetup.initialize(
        developmentMode = false,
        jsEvaluationConfig = JSEvaluationConfig()
    )

    startApp()
}

@OptIn(ExperimentalComposeUiApi::class)
private fun startApp() {
    onWasmReady {
        ComposeViewport(document.body!!) {

            val fontFamilyResolver = LocalFontFamilyResolver.current
            val emoji = Font(Res.font.noto_color_emoji_regular, weight = FontWeight.Normal)
            LaunchedEffect(emoji) {
                val fontFamily = FontFamily(listOf(emoji))
                fontFamilyResolver.preload(fontFamily)
            }

            AppCreator()
        }
    }
}
